const theme = {
  primaryButton: {
    marginRight: `10px`,
    padding: `10px 50px 7px 45px`,
    fontFamily: `"DIN Web",sans-serif`,
    fontWeight: `normal`,
    fontSize: `1rem`,
    color: `#fff`,
    textTransform: `uppercase`,
    textDecoration: `none`,
    backgroundColor: `#a6192e`,
    border: `2px solid #a6192e !important`,
    borderRadius: `0`,
    hover: {
      color: `#a6192e !important`,
      backgroundColor: `#fff !important`,
      border: `2px solid #a6192e !important`,
    },
    mobile: {
      padding: `10px 38px 7px 33px`,
    },
  },
  fileUpload: {
    display: `inline-flex`,
    padding: `0`,
    fontFamily: `"DIN Web",sans-serif`,
    fontWeight: `normal`,
    fontSize: `1rem`,
    color: `#fff`,
    textTransform: `uppercase`,
    textDecoration: `none`,
    verticalAlign: `bottom`,
    backgroundColor: `#a6192e`,
    border: `2px solid #a6192e !important`,
    borderRadius: `0`,
    cursor: `pointer`,
    hover: {
      color: `#a6192e !important`,
      backgroundColor: `#fff !important`,
      border: `2px solid #a6192e !important`,
    },
    button: {
      padding: `5px 20px 5px 21px`,
      background: `0 !important`,
      border: `0 !important`,
      borderRadius: `0`,
      hover: {
        color: `#a6192e`,
      },
    },
  },
};

export default theme;
